module.exports = __webpack_public_path__ + "img/sbp-pay.c9f75913.svg";